(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.PgisService = (function(superClass) {
    extend(PgisService, superClass);

    function PgisService(http, rootScope, q) {
      this.http = http;
      this.rootScope = rootScope;
      this.q = q;
      this.addZonesToMapIfNeeded = bind(this.addZonesToMapIfNeeded, this);
      this.getProductivityZone = bind(this.getProductivityZone, this);
      this.getPreviousCropZone = bind(this.getPreviousCropZone, this);
      this.getIrrigationZone = bind(this.getIrrigationZone, this);
      this.setProductivityZone = bind(this.setProductivityZone, this);
      this.setPreviousCropZone = bind(this.setPreviousCropZone, this);
      this.setIrrigationZone = bind(this.setIrrigationZone, this);
      this.getZoneObject = bind(this.getZoneObject, this);
      this.deleteFromLayerStore = bind(this.deleteFromLayerStore, this);
      this.fieldDataGeoJsonToBoundaryLayer = bind(this.fieldDataGeoJsonToBoundaryLayer, this);
      this.fitBounds = bind(this.fitBounds, this);
      this.geojsonToLeaflet = bind(this.geojsonToLeaflet, this);
      this.clearBoundaryLayer = bind(this.clearBoundaryLayer, this);
      this.loadBoundaryLayer = bind(this.loadBoundaryLayer, this);
      this.adjustBoundaryLayer = bind(this.adjustBoundaryLayer, this);
      this.setZoneObject = bind(this.setZoneObject, this);
      this.setFieldData = bind(this.setFieldData, this);
      this.setBoundaryLayer = bind(this.setBoundaryLayer, this);
      this.cleanup = bind(this.cleanup, this);
      this.removeAddedLayers = bind(this.removeAddedLayers, this);
      this.added_layers = [];
    }

    PgisService.prototype.clipAll = function(layer_one, collection, field) {
      return this.http.post('backend/grower/fields/define/clip-all', {
        layer_one: layer_one,
        collection: collection,
        field: field
      });
    };

    PgisService.prototype.cleanse = function(layer) {
      return this.http.post('backend/grower/fields/define/cleanse', {
        data: layer
      });
    };

    PgisService.prototype.geojsonToWkt = function(geojson) {
      return this.http.post('backend/grower/fields/define/geojson-to-wkt', {
        geojson: geojson
      });
    };

    PgisService.prototype.removeAddedLayers = function() {
      var i, layer, len, ref, results;
      ref = this.added_layers;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        layer = ref[i];
        results.push(App.map.removeLayer(layer));
      }
      return results;
    };

    PgisService.prototype.cleanup = function() {
      this.setBoundaryLayer(null);
      this.setFieldData(null);
      this.setZoneObject(null);
      this.setProductivityZone(null);
      this.setPreviousCropZone(null);
      return this.setIrrigationZone(null);
    };

    PgisService.prototype.setBoundaryLayer = function(boundary_layer) {
      this.boundary_layer = boundary_layer;
      return void 0;
    };

    PgisService.prototype.setFieldData = function(field_data1) {
      this.field_data = field_data1;
      return void 0;
    };

    PgisService.prototype.setZoneObject = function(zone_object) {
      this.zone_object = zone_object;
      return void 0;
    };

    PgisService.prototype.adjustBoundaryLayer = function(field_data) {
      if (field_data.boundary != null) {
        if (App.map.hasLayer(field_data.boundary)) {
          App.map.removeLayer(field_data.boundary);
        }
      }
      if (field_data.boundary_layer != null) {
        if (App.map.hasLayer(field_data.boundary_layer)) {
          App.map.removeLayer(field_data.boundary_layer);
        }
      }
      if (this.boundary_layer) {
        if (App.map.hasLayer(this.boundary_layer)) {
          return App.map.removeLayer(this.boundary_layer);
        }
      }
    };

    PgisService.prototype.loadBoundaryLayer = function(fit_bound) {
      if (fit_bound == null) {
        fit_bound = false;
      }
      if (!App.map.hasLayer(this.boundary_layer)) {
        App.map.addLayer(this.boundary_layer);
      }
      if (fit_bound) {
        return this.fitBounds(this.boundary_layer);
      }
    };

    PgisService.prototype.clearBoundaryLayer = function() {
      return App.map.eachLayer((function(_this) {
        return function(l) {
          if (l === _this.boundary_layer) {
            return App.map.removeLayer(_this.boundary_layer);
          }
        };
      })(this));
    };

    PgisService.prototype.geojsonToLeaflet = function(geojson) {
      return L.geoJson(geojson, {
        style: (function(_this) {
          return function() {
            return {
              color: '#0F0',
              weight: 2
            };
          };
        })(this)
      });
    };

    PgisService.prototype.fitBounds = function(layer) {
      return App.map.fitBounds(layer.getBounds());
    };

    PgisService.prototype.fieldDataGeoJsonToBoundaryLayer = function(field_data, load, fit_bound) {
      var boundary;
      if (load == null) {
        load = false;
      }
      if (fit_bound == null) {
        fit_bound = false;
      }
      if (load) {
        this.adjustBoundaryLayer(field_data);
      }
      boundary = this.geojsonToLeaflet(field_data.boundary);
      this.setBoundaryLayer(boundary);
      if (load) {
        return this.loadBoundaryLayer(fit_bound);
      }
    };

    PgisService.prototype.deleteFromLayerStore = function(id) {
      return App.layer_store["delete"](id);
    };

    PgisService.prototype.getZoneObject = function() {
      return this.zone_object;
    };

    PgisService.prototype.setIrrigationZone = function(irrigation_zone) {
      this.irrigation_zone = irrigation_zone;
      return void 0;
    };

    PgisService.prototype.setPreviousCropZone = function(previous_crop_zone) {
      this.previous_crop_zone = previous_crop_zone;
      return void 0;
    };

    PgisService.prototype.setProductivityZone = function(productivity_zone) {
      this.productivity_zone = productivity_zone;
      return void 0;
    };

    PgisService.prototype.getIrrigationZone = function() {
      return this.irrigation_zone;
    };

    PgisService.prototype.getPreviousCropZone = function() {
      return this.previous_crop_zone;
    };

    PgisService.prototype.getProductivityZone = function() {
      return this.productivity_zone;
    };

    PgisService.prototype.addZonesToMapIfNeeded = function(zone) {
      var area, i, len, ref, results;
      ref = zone.zones;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        area = ref[i];
        if (!App.map.hasLayer(area.visible)) {
          results.push(App.map.addLayer(area.visible));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return PgisService;

  })(Service);

}).call(this);
